<template>
	<c-dialog ref="dialog" title="维修记录详情" mode="slide" width="600" enable-flex mask-close :button="false">
		<c-title>维修信息</c-title>
		<c-detail class="m-detail-table" column="1" style="padding-top: 0;">
			<c-detail-item label="背贴码">{{info.produce_unique_code || '-'}}</c-detail-item>
			<c-detail-item label="型号">{{info.model_name || '-'}}</c-detail-item>
			<c-detail-item label="IMEI">{{info.produce_imei || '-'}}</c-detail-item>
			<c-detail-item label="维修人">{{info.create_user_name || '-'}}</c-detail-item>
			<c-detail-item label="维修金额">
				<span style="color: #FF6900;">￥{{totalAmount}}</span>
			</c-detail-item>
			<c-detail-item label="创建时间">{{info.create_date || '-'}}</c-detail-item>
			<c-detail-item label="完成时间">{{info.complete_date || '-'}}</c-detail-item>
			<c-detail-item label="备注">{{info.remark || '-'}}</c-detail-item>
		</c-detail>

		<c-title>维修项目</c-title>
		<c-detail class="m-detail-table" column="1" style="padding-top: 0;">
			<c-detail-item v-for="(item, i) in detailList" :key="i" :label="getItemName(item.repair_item)">
				￥{{item.repair_amount}}
			</c-detail-item>
		</c-detail>
	</c-dialog>
</template>

<script>
export default {
	name: 'repairRecordDetailDialog',

	data() {
		return {
			info: {},
			detailList: [],
			/*维修项字典，明细表只存 repair_item 代码，label 要显示名称*/
			itemOptions: []
		}
	},

	computed: {
		// 明细金额合计，含负数冲减项，与主表维修成本口径一致
		totalAmount() {
			return this.detailList.reduce((sum, item) => sum + Number(item.repair_amount || 0), 0).toFixed(2);
		}
	},

	methods: {
		/*********打开弹框**********/
		open(data) {
			this.info = {};
			this.detailList = [];
			this.loadItemOptions();
			this.$refs.dialog.open();

			this.request({
				url: '/repair/record/detail',
				data: {id: data.id},
				loading: true,
				success: (result) => {
					this.info = result.info || {};
					this.detailList = result.details || [];
				}
			});
		},

		/*********加载维修项字典**********/
		loadItemOptions() {
			if (this.itemOptions.length) return;
			this.request({
				url: '/system/dic/options',
				data: {dic_type_code: 'REPAIR_ITEM'},
				success: (data) => {
					this.itemOptions = data || [];
				}
			});
		},

		/*********维修项名称**********/
		getItemName(item) {
			var matched = this.itemOptions.find(option => option.value == item);
			return matched ? matched.name : '-';
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>
